import { render } from "./BottomPlayer.vue?vue&type=template&id=e760469e"
import script from "./BottomPlayer.vue?vue&type=script&lang=js"
export * from "./BottomPlayer.vue?vue&type=script&lang=js"

import "./BottomPlayer.vue?vue&type=style&index=0&id=e760469e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__